import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {NbDatepickerModule, NbInputModule, NbRadioModule} from "@nebular/theme";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-form-datetime',
  standalone: true,
  imports: [CommonModule, NbInputModule, ReactiveFormsModule, NbDatepickerModule, NbRadioModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormDatetimeComponent),
      multi: true
    }
  ],
  templateUrl: './form-datetime.component.html',
  styleUrl: './form-datetime.component.scss'
})
export class FormDatetimeComponent implements ControlValueAccessor {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() withSeconds: boolean = false;
  @Input() required: boolean = false;
  @Input() control?: FormControl;
  @Input() showErrors: boolean = true;
  @Input() requiredMessage: string = '';

  value: Date | null = null;
  disabled: boolean = false;

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: Date | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event:  Date | null): void {
    this.value = event;
    this.onChange(this.value);
  }
}
